<template>
    <div class="truncate text-secondary cursor-pointer select-none" @click="$emit('click', $event)">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "ListItem",
        props: {
            twoLine: {type: Boolean, default: false},
            threeLine: {type: Boolean, default: false},
            justifyItems: {type: String, default: 'space-between'}
        },
    }
</script>

<style scoped>

</style>